module.exports = __webpack_public_path__ + "img/military_base-hotspot-3.ce91b927.png";